import { render, staticRenderFns } from "./university.vue?vue&type=template&id=060899e2&scoped=true"
import script from "./university.vue?vue&type=script&lang=js"
export * from "./university.vue?vue&type=script&lang=js"
import style0 from "./university.vue?vue&type=style&index=0&id=060899e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060899e2",
  null
  
)

export default component.exports